import type { AvailableTechnician, Schedule, SchedulePayload } from '../types';
import { apiClient } from './client';

export const scheduling = {
  getSchedules: async (startDate: string, endDate: string): Promise<{ schedules: Schedule[] }> => {
    const { data } = await apiClient.get<{ schedules: Schedule[] }>('/api/scheduling/schedules', {
      params: { start_date: startDate, end_date: endDate },
    });
    return data;
  },

  scheduleJob: async (payload: SchedulePayload): Promise<Schedule> => {
    const { data } = await apiClient.post<{ schedule: Schedule; warnings?: unknown[]; conflicts?: unknown[] }>(
      '/api/scheduling/schedules',
      payload,
    );
    return data.schedule;
  },

  getAvailableTechnicians: async (
    startDate: string,
    endDate: string,
  ): Promise<{ technicians: AvailableTechnician[] }> => {
    const { data } = await apiClient.get<{ technicians: AvailableTechnician[] }>(
      '/api/scheduling/available-technicians',
      {
        params: { start_date: startDate, end_date: endDate },
      },
    );
    return data;
  },
};
